// Este archivo inicializa la conexión con Firebase usando las credenciales seguras del .env

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Inicializa la app de Firebase
const app = initializeApp(firebaseConfig);

// Exporta el módulo de autenticación para que lo podamos usar en cualquier parte de la app
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);